{
  "name": "bbc-player-web",
  "version": "2.1.2",
  "private": true,
  "dependencies": {
    "@brightcove/react-player-loader": "^1.3.0",
    "@brightcove/studio-colors": "^3.2.0",
    "@brightcove/studio-components": "^0.42.0",
    "@brightcove/studio-icons": "^7.2.1",
    "@vitejs/plugin-react": "^6.0.2",
    "classnames": "^2.2.6",
    "env-cmd": "^10.0.1",
    "eventemitter3": "^4.0.0",
    "express": "^4.17.1",
    "express-favicon": "^2.0.1",
    "express-xml-bodyparser": "^0.4.1",
    "jwt-decode": "^2.2.0",
    "lodash": "^4.17.21",
    "moment": "^2.24.0",
    "node-fetch": "^2.6.0",
    "query-string": "^9.1.1",
    "react": "^16.10.2",
    "react-circular-progressbar": "^2.0.3",
    "react-dom": "^16.10.2",
    "react-helmet": "^5.2.1",
    "react-modal": "^3.11.1",
    "react-redux": "^7.1.3",
    "react-responsive": "^8.0.1",
    "react-router": "^5.1.2",
    "react-router-dom": "^5.1.2",
    "redux": "^4.0.4",
    "sanitize-html": "^2.17.4",
    "sass": "^1.87.0",
    "typescript": "^5.8.3",
    "vite": "^8.0.16",
    "vite-plugin-svgr": "^4.3.0"
  },
  "scripts": {
    "dev": "vite",
    "build": "vite build --mode $NODE_ENV",
    "preview": "vite preview",
    "lint": "true",
    "test": "true",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui"
  },
  "eslintConfig": {
    "extends": "react-app"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@playwright/test": "^1.59.1",
    "@types/jest": "^24.0.19",
    "@types/moment": "^2.13.0",
    "@types/node": "^22.19.17",
    "@types/react": "^16.9.9",
    "@types/react-dom": "^16.9.2",
    "@types/react-responsive": "^8.0.1",
    "@types/react-router": "^5.1.2",
    "@types/react-router-dom": "^5.1.0",
    "esbuild": "^0.28.1"
  }
}
